import { useDispatch, useSelector } from "react-redux"
import { getInterest } from "reducers/userInfo"
import { getHasPartnerInfo } from "derivedSelectors"
import { updateInterest } from "actions/userActions"
import Interests from "utils/Interests"
import { FleLayout } from "components/views/fle/FleLayout"
import { TopSection } from "components/views/fle/TopSection"
import { BackArrow, SkipArrow, SwitchH2ToBodyLarge } from "components/views/fle/Molecules"
import { Spacer } from "components/views/atoms/Atoms"
import GetInterestChoices from "content/InterestChoices"
import { Button } from "components/views/atoms/buttons/Button"
import { FleLinkWrapper } from "components/views/atoms/Links"
import React from "react"
import L10n from "lib/carrot-l10n"
import { JourneyPaths } from "./JourneyPaths"
import { getJourney } from "../../../../reducers/userInfo"
import Journeys from "../../../../utils/Journeys"
import { getBenefitConfiguration } from "reducers/benefitConfiguration"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const JourneyInterestContainer = ({ title, somethingElseNext, history, interestsToExclude, toDone }) => {
  const benefitConfiguration = useSelector(getBenefitConfiguration)
  const { journey, interest, hasPartner } = useSelector((state) => ({
    journey: getJourney(state),
    interest: getInterest(state),
    hasPartner: getHasPartnerInfo(state)
  }))

  const dispatch = useDispatch()

  const submitInterest = async (journey, interest) => {
    await dispatch(updateInterest(interest, null))
    const interestIsArt = [
      Interests.EMBRYO_FREEZING,
      Interests.EGG_FREEZING,
      Interests.SPERM_FREEZING,
      Interests.IVF,
      Interests.IUI
    ].includes(interest)

    let next = toDone
    if (interest === Interests.SOMETHING_ELSE) {
      next = somethingElseNext
    } else if (journey === Journeys.TAKING_ACTION) {
      next = JourneyPaths.DONE
    } else if (interest === Interests.ADOPTING || interest === Interests.GESTATIONAL_CARRIER) {
      next = toDone
    } else if (interestIsArt) {
      next = JourneyPaths.TALKED_TO_DOCTOR
    } else if (interest === Interests.UNDERSTAND_MY_FERTILITY || interest === Interests.PREGNANCY) {
      next = JourneyPaths.INITIAL_CONSULTATION
    }
    history.push(next)
  }
  return (
    <FleLayout>
      <TopSection progressStep={4} leftOrBackArrow={<BackArrow />} />
      <SwitchH2ToBodyLarge>{title}</SwitchH2ToBodyLarge>
      <Spacer height={2} />
      <div className="flex flex-row flex-wrap justify-end w-100">
        {GetInterestChoices().map(({ id, labelKey, pronouns, filter }) => {
          if (interestsToExclude && interestsToExclude.includes(id)) {
            return null
          }
          if (filter && !filter(benefitConfiguration)) {
            return null
          }

          const pronoun = hasPartner ? pronouns?.plural : pronouns?.singular
          const label = l(labelKey, { pronoun })
          return (
            <div key={id} className="ml1 mb1">
              <Button bold={false} onClick={() => submitInterest(journey, id)} horizontalPadding={4}>
                {label}
              </Button>
            </div>
          )
        })}
      </div>
      <FleLinkWrapper>
        <SkipArrow to={JourneyPaths.DONE} />
      </FleLinkWrapper>
    </FleLayout>
  )
}

export { JourneyInterestContainer }
